import React from 'react';
import {
  DownloadIcon,
  ExpandIcon,
  ExternalLinkIcon,
  InternalLinkIcon,
  PlayIcon,
  PDFIcon
} from 'zoomforth_component_lib/external_modern_icons.jsx';
import Image from 'zoomforth_codesbane_viewer/component_lib/image.jsx';


const getActionIndicatorTypeIcon = (indicatorType, props)=> {
  
  // if the indicatorType is an object with a type
  if(indicatorType && indicatorType.type){
    switch (indicatorType.type) {
    case 'custom':
      return (
          <Image 
            style={{ height: '100%', width: '100%' }}
            zfImage={indicatorType.zfImage}
            src={indicatorType.display_image}
          />
        );
    default:
      throw new Error(`Unexpected indicatorType.type: ${indicatorType}`);
    }
  }

  switch (indicatorType) {
  case 'video':
    return <PlayIcon {...props} />;

  case 'other':
    return <DownloadIcon {...props} />;

  case 'pdf':
    return <PDFIcon {...props} />;

  case 'photo':
  case 'ppt':
  case 'embed':
    return <ExpandIcon {...props} />;

  case 'link': // Meaning external-link
    return <ExternalLinkIcon {...props} />;

  case 'internal-link':
    return <InternalLinkIcon {...props} />;

  default:
    throw new Error(`Unexpected indicatorType: ${indicatorType}`);
  }
};


export default ({ indicatorType, ...props })=>
  getActionIndicatorTypeIcon(indicatorType, props);
